import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DeviceUtilsService {
  // TODO V : remettre a true
  public isMobileSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  sidebarClosingSubject = new Subject<void>();

  constructor(public breakpointObserver: BreakpointObserver) {}

  get isMobile$(): Observable<boolean> {
    return this.isMobileSubject.pipe(distinctUntilChanged());
  }

  breakpointChanged(isMobile: boolean): void {
    this.isMobileSubject.next(isMobile);
  }

  sidebarCloseActivate(): void {
    this.sidebarClosingSubject.next();
  }

  /*   redirectToDevice(): void {
    this.isMobile$.subscribe(isMobile => {
      if (isMobile) {
        this.router.navigate(['/mobile']);
      } else {
        this.router.navigate(['/desktop']);
      }
    });
  } */
}
